<template>
  <b-container>
    <b-row class="vh-100" align-v="center" align-h="center">
      <b-col cols="10">
        <img
          src="@/assets/media/logo-mobile.jpg"
          alt="Servicestart logo"
          class="logo"
          width="140"
          height="140"
          style="margin-bottom:10px;"
        />
        <LoginForm />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import LoginForm from '@/components/LoginForm.vue';

export default {
  components: {
    LoginForm,
  },
  metaInfo() {
    return {
      title: this.$t('user.login'),
    };
  },
};
</script>
